import { forwardRef, type Ref, type SVGProps } from "react";
const IconFireplaceFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 15.85C2 8.2 8.268 2 16 2s14 6.2 14 13.85v9.188a.97.97 0 0 1-.972.962H2.972A.967.967 0 0 1 2 25.038zm4-.617C6 10.133 10.477 6 16 6s10 4.134 10 9.233v6.126c0 .354-.311.641-.694.641h-5.432A5.1 5.1 0 0 0 21 18.815c0-1.67-.98-2.849-1.826-3.863l-.22-.266c-.922-1.12-1.717-2.222-1.717-3.964a.72.72 0 0 0-.561-.704.7.7 0 0 0-.322 0c-1.3.293-2.09.935-2.527 1.753-.412.77-.46 1.616-.482 2.206l-.007.198q-.006.202-.014.35a6 6 0 0 1-.61-.36.71.71 0 0 0-.89.073l-.002.002-.002.002-.007.007a5 5 0 0 0-.3.325 6.3 6.3 0 0 0-.62.89 6.66 6.66 0 0 0-.893 3.35c0 1.153.408 2.288 1.12 3.186H6.695C6.311 22 6 21.713 6 21.359zM5.786 28C5.352 28 5 28.448 5 29s.352 1 .786 1h20.428c.434 0 .786-.448.786-1s-.352-1-.786-1z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFireplaceFilledSVG);
ForwardRef.displayName = "IconFireplaceFilled";
export { ForwardRef as IconFireplaceFilled };
